import type { QuestionLevel } from "./types";

export const QUESTION_LEVELS: readonly QuestionLevel[] = [1, 2, 3] as const;

export const QUESTION_TYPE = {
  TEXT_ANSWER: "TEXT-ANSWER",
  TEXT_ANSWERS: "TEXT-ANSWERS",
  BOOLEAN: "BOOLEAN",
  DESCRIPTIVE: "DESCRIPTIVE",
  RADIO: "RADIO",
  SINGLE: "SINGLE",
  SINGLE_CHOICE: "SINGLE_CHOICE",
  SINGLE_ANSWER: "SINGLE-ANSWER",
  CHECKBOX: "CHECKBOX",
  MULTIPLE: "MULTIPLE",
  MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
  MULTIPLE_ANSWER: "MULTIPLE-ANSWER",
} as const;

export const ALERT_MESSAGE = {
  LOAD_FAIL: "Failed to load questions for this level.",
  SAVE_SUCCESS: "Answer has been saved successfully.",
  SAVE_FAIL: "Failed to save answers.",
  SAVE_ERROR: "Something went wrong. Please try again.",
  ANSWER_ONE_REQUIRED: "Please answer at least one question.",
} as const;
